import React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap'

const Paginator = ({page, total, change}) => {
    const firstPage = page === 0;
    const lastPage = page === (total - 1)

    const range = 7;
    let start = 0;

    let paging = []; 
    // Don't use negative values, force start at 1
    if (page < (range / 2) + 1) {
        start = 0;
        // Don't go beyond the last page 
    } else if (page >= (total - (range / 2))) {
        start = Math.floor(total - range);
    } else {
        start = (page - Math.floor(range / 2));
    }

    for (let i = start; i <= ((start + range) - 1); i++) {
        if (i < total)
            paging.push(i);
    }

    const pages = paging.map((num) => (
        <PaginationItem active={num === page} key={num}>
            <PaginationLink onClick={() => change(num)}>
                {num + 1}
            </PaginationLink>
        </PaginationItem>
    ));

    return (
        <Pagination aria-label="Page navigation example" className="ml-3">
            <PaginationItem disabled={firstPage}>
                <PaginationLink first onClick={() => change(0)} />
            </PaginationItem>
            <PaginationItem disabled={firstPage}>
                <PaginationLink previous onClick={() => change(page - 1)} />
            </PaginationItem>
            { pages }
            <PaginationItem disabled={lastPage}>
                <PaginationLink next onClick={() => change(page + 1)} />
            </PaginationItem>
            <PaginationItem disabled={lastPage}>
                <PaginationLink last onClick={() => change(total - 1)} />
            </PaginationItem>
        </Pagination>
    );
}

export default Paginator;